import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Icon.scss';
import { ReactComponent as Hourglass } from './icons/hourglass.svg';
import { ReactComponent as Arrow } from './icons/arrow.svg';
import { ReactComponent as DropdownArrow } from './icons/dropdown-arrow.svg';
import { ReactComponent as Clock } from './icons/clock.svg';
import { ReactComponent as Calendar } from './icons/calendar.svg';
import { ReactComponent as Email } from './icons/email.svg';
import { ReactComponent as Password } from './icons/password.svg';
import { ReactComponent as Carriage } from './icons/carriage.svg';
import { ReactComponent as Dog } from './icons/dog.svg';
import { ReactComponent as Horse } from './icons/horse.svg';
import { ReactComponent as Close } from './icons/close.svg';
import { ReactComponent as Menu } from './icons/menu.svg';
import { ReactComponent as Facebook } from './icons/facebook.svg';
import { ReactComponent as Twitter } from './icons/twitter.svg';
import { ReactComponent as Pdf } from './icons/pdf.svg';
import { ReactComponent as Search } from './icons/search.svg';
import { ReactComponent as SearchActive } from './icons/search-active.svg';
import { ReactComponent as User } from './icons/user.svg';
import { ReactComponent as Filter } from './icons/filter.svg';
import { ReactComponent as FilterActive } from './icons/filter-active.svg';
import { ReactComponent as Betslip } from './icons/betslip.svg';
import { ReactComponent as Home } from './icons/home.svg';
import { ReactComponent as ErrorIcon } from './icons/error.svg';
import { ReactComponent as Info } from './icons/info.svg';
import { ReactComponent as Success } from './icons/success.svg';
import { ReactComponent as Warning } from './icons/warning.svg';
import { ReactComponent as Check } from './icons/check.svg';
import { ReactComponent as RadioButtonOpen } from './icons/radio-button-open.svg';
import { ReactComponent as RadioButton } from './icons/radio-button.svg';
import { ReactComponent as BetSlideIconNotClicked } from './icons/betslip-icon-notclicked.svg';
import { ReactComponent as BetSlideIcon } from './icons/betslip-icon.svg';
import { ReactComponent as Graph } from './icons/graph.svg';
import { ReactComponent as EyeOpen } from './icons/eye-open.svg';
import { ReactComponent as EyeClosed } from './icons/eye-closed.svg';
import { ReactComponent as Reload } from './icons/reload.svg';
import { ReactComponent as Trashcan } from './icons/trashcan.svg';
import { ReactComponent as Cog } from './icons/cog.svg';
import { ReactComponent as Trash } from './icons/trash.svg';
import { ReactComponent as Star } from './icons/star.svg';
import { ReactComponent as MenuOpened } from './icons/menu-opened.svg';
import { ReactComponent as Chronometer } from './icons/chronometer.svg';
import { ReactComponent as More } from './icons/more.svg';
import { ReactComponent as Less } from './icons/less.svg';
import { ReactComponent as Padlock } from './icons/padlock.svg';
import { ReactComponent as GoUpArrow } from './icons/go-up-arrow.svg';
import { ReactComponent as Streaming } from './icons/streamicon.svg';
import { ReactComponent as BetslipMobile } from './icons/betslipMobile.svg';
import { ReactComponent as TransparentSearch } from './icons/transparentSearch.svg';
import { ReactComponent as Tooltip } from './icons/tooltip-icon.svg';
import { ReactComponent as FilledI } from './icons/i-filled.svg';
import { ReactComponent as SearchIcon } from './icons/search-icon.svg';
import { ReactComponent as Meetings } from './icons/meetings.svg';
import { ReactComponent as NumberIcon } from './icons/lotto-icon.svg';
import { ReactComponent as BackArrow } from './icons/back-arrow.svg';
import { ReactComponent as WarningFilled } from './icons/warning-filled.svg';
import { ReactComponent as Checkbox } from './icons/checkbox.svg';
import { ReactComponent as Checked } from './icons/checked.svg';
import { ReactComponent as CheckboxSmall } from './icons/checkbox-small.svg';
import { ReactComponent as Return } from './icons/return.svg';
import { ReactComponent as History } from './icons/history.svg';
import { ReactComponent as Won } from './icons/won-icon.svg';
import { ReactComponent as Lost } from './icons/Lost-icon.svg';
import { ReactComponent as Voided } from './icons/void-icon.svg';
import { ReactComponent as PartiallyPaid } from './icons/half-won-icon.svg';
import { ReactComponent as FullStakeBack } from './icons/stake-back-icon.svg';
import { ReactComponent as HalfStakeBack } from './icons/half-stake-back-icon.svg';
import { ReactComponent as Refund } from './icons/refund-icon.svg';
import { ReactComponent as LateBet } from './icons/late-bet-icon.svg';
import { ReactComponent as LiveStats } from './icons/graph-live.svg';
import { ReactComponent as Coins } from './icons/coins.svg';
import { ReactComponent as Bills } from './icons/bills.svg';
import { ReactComponent as Cards } from './icons/cards.svg';
import { ReactComponent as UnDock } from './icons/undock.svg';
import { ReactComponent as Numpad } from './icons/numpad.svg';
import { ReactComponent as CashLog } from './icons/cashlog.svg';
import { ReactComponent as Calculator } from './icons/calculator.svg';
import { ReactComponent as descending } from './icons/descending.svg';
import { ReactComponent as ascending } from './icons/ascending.svg';
import { ReactComponent as trackerbetslip } from './icons/trackerbetslip.svg';
import { ReactComponent as Matchtracker } from './icons/matchtracker.svg';
import { ReactComponent as Reuse } from './icons/reuse.svg';
import { ReactComponent as LockedSquare } from './icons/locked-square.svg';
import { ReactComponent as Minimize } from './icons/minimize.svg';
import { ReactComponent as Maximize } from './icons/maximize.svg';
import { ReactComponent as MenuClosedFilter } from './icons/menu-closed-filter.svg';
import { ReactComponent as MenuClosedBetslip } from './icons/menu-closed-betslip.svg';


const icons = {
  hourglass: { svg: Hourglass, type: 'fill' },
  arrow: { svg: Arrow, type: 'stroke' },
  clock: { svg: Clock, type: 'stroke' },
  calendar: { svg: Calendar, type: 'fill' },
  email: { svg: Email, type: 'fill' },
  password: { svg: Password, type: 'fill' },
  carriages: { svg: Carriage, type: 'fill' },
  dogs: { svg: Dog, type: 'fill' },
  horses: { svg: Horse, type: 'fill' },
  close: { svg: Close, type: 'fill' },
  menu: { svg: Menu, type: 'fill' },
  facebook: { svg: Facebook, type: 'fill' },
  twitter: { svg: Twitter, type: 'fill' },
  pdf: { svg: Pdf, type: 'fill' },
  search: { svg: Search, type: 'stroke' },
  searchActive: { svg: SearchActive, type: 'stroke' },
  dropdownArrow: { svg: DropdownArrow, type: 'mixed' },
  user: { svg: User, type: 'fill' },
  filter: { svg: Filter, type: 'fill' },
  filterActive: { svg: FilterActive, type: 'fill' },
  betslip: { svg: Betslip, type: 'stroke' },
  home: { svg: Home, type: 'fill' },
  error: { svg: ErrorIcon, type: 'fill' },
  info: { svg: Info, type: 'fill' },
  success: { svg: Success, type: 'fill' },
  warning: { svg: Warning, type: 'fill' },
  check: { svg: Check, type: 'fill' },
  radioButtonOpen: { svg: RadioButtonOpen, type: 'fill' },
  radioButton: { svg: RadioButton, type: 'stroke' },
  betSlipIconNotClicked: { svg: BetSlideIconNotClicked, type: 'stroke' },
  betSlipIcon: { svg: BetSlideIcon, type: 'stroke' },
  graph: { svg: Graph, type: 'fill ' },
  eyeOpen: { svg: EyeOpen, type: 'fill' },
  eyeClosed: { svg: EyeClosed, type: 'fill' },
  reload: { svg: Reload, type: 'fill' },
  trashcan: { svg: Trashcan, type: 'fill' },
  cog: { svg: Cog, type: 'fill' },
  trash: { svg: Trash, type: 'stroke' },
  star: { svg: Star, type: 'stroke' },
  menuOpened: { svg: MenuOpened, type: 'fill' },
  chronometer: { svg: Chronometer, type: 'mixed' },
  more: { svg: More, type: 'fill' },
  less: { svg: Less, type: 'fill' },
  padlock: { svg: Padlock, type: 'fill' },
  GoUpArrow: { svg: GoUpArrow, type: 'stroke' },
  streaming: { svg: Streaming, type: 'stroke' },
  BetslipMobile: { svg: BetslipMobile, type: 'stroke' },
  TransparentSearch: { svg: TransparentSearch, type: 'mixed' },
  Tooltip: { svg: Tooltip, type: 'mixed' },
  filledI: { svg: FilledI, type: 'stroke' },
  searchIcon: { svg: SearchIcon, type: 'stroke' },
  backArrow: { svg: BackArrow, type: 'fill' },
  warningFilled: { svg:WarningFilled, type: 'fill' },
  meetings: { svg: Meetings, type: 'fill' },
  numberIcon: { svg: NumberIcon, type: 'fill' },
  checkbox: { svg: Checkbox, type: 'mixed' },
  checked: { svg: Checked, type: 'stroke' },
  checkboxSmall: { svg: CheckboxSmall, type: 'stroke' },
  return: { svg: Return, type: 'mixed' },
  history: { svg: History, type: 'mixed' },
  won: { svg: Won, type: 'stroke' },
  lost: { svg: Lost, type: 'stroke' },
  voided: { svg: Voided, type: 'stroke' },
  partiallyPaid: { svg: PartiallyPaid, type: 'stroke' },
  fullStakeBack: { svg: FullStakeBack, type: '' },
  halfStakeBack: { svg: HalfStakeBack, type: '' },
  refund: { svg: Refund, type: 'stroke' },
  lateBet: { svg: LateBet, type: 'stroke' },
  liveStats: { svg: LiveStats, type: 'fill' },
  coins: { svg: Coins, type: 'stroke' },
  bills: { svg: Bills, type: 'stroke' },
  cards: { svg: Cards, type: 'stroke' },
  unDock: { svg: UnDock, type: 'fill' },
  numpad: { svg: Numpad, type: 'mixed' },
  cashLog: { svg: CashLog, type: 'mixed' },
  calculator: { svg: Calculator, type: 'mixed' },
  descending: { svg: descending, type: 'fill' },
  ascending: { svg: ascending, type: 'fill' },
  trackerBetslip: { svg: trackerbetslip, type: 'stroke' },
  matchtracker: { svg: Matchtracker, type: 'mixed' },
  reuse: { svg: Reuse, type: 'mixed' },
  lockedSquare: { svg: LockedSquare, type: 'mixed' },
  minimize: { svg: Minimize, type: 'stroke' },
  maximize: { svg: Maximize, type: 'stroke' },
  menuClosedFilter: { svg: MenuClosedFilter, type: '' },
  menuClosedBetslip: { svg: MenuClosedBetslip, type: '' }
};

class Icon extends PureComponent {

  render() {
    const { icon, className } = this.props;
    const SelectedIcon = icon && icons[icon] && icons[icon].svg;

    if (SelectedIcon) {
      return (
        <SelectedIcon
          { ...this.props }
          className={
            classNames({
              [`icon--${ icons[icon].type }`]: true,
              [className]: className
            })
          }
        />
      );
    } else {
      return null;
    }
  }

}

Icon.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string
};

export default Icon;
